import React from 'react';
import { Text, Link } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import Button from '../Shared/components/controls/Button';
const SubmitNewApplication = (props) => {
  return (
    <div className="containerCard">
      <div className='CardContianer'>
        <div className="container__left">
          <div className="title">
            <Text field={props?.fields?.Title} />
          </div>
          <div className="subTitle">
            <Text field={props?.fields?.Subtitle} />
          </div>
        </div>
        <div className="container__right">
          <Link field={props?.fields?.Link} className="button button-contained-primary" />
        </div>
      </div>
    </div>
  );
};

export default SubmitNewApplication;
